import { buildTestsQueryVariables } from 'src/apps/dashboard/services/queries/sessions/helpers/buildVariables';
import { transformTestsResults } from 'src/apps/dashboard/services/queries/sessions/helpers/transformResults';
import { DashboardWfaSessionsQuery } from 'src/apps/dashboard/services/queries/sessions/Sessions.generated';
import {
	IGeWfaSessionsParams,
	TWfaSessionsResult
} from 'src/apps/dashboard/types/WfaDashboardServiceTypes';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

import { DashboardWfaSessions } from '../queries/sessions/Sessions.gql';

export const getWfaSessions = async (params: IGeWfaSessionsParams): Promise<TWfaSessionsResult> => {
	try {
		const variables = buildTestsQueryVariables(params);

		const query = DashboardWfaSessions;
		const result = await gqlClient.request<DashboardWfaSessionsQuery>(query, variables);

		return transformTestsResults(result);
	} catch (e) {
		Logger.error('WfaSessionsService.ts -> getWfaSessions failed with an error:', e);
		throw e;
	}
};
